// @flow

import React from "react";

type Props = {
  color?: string,
  height?: number,
  width?: number
};

const Down = ({ color, height = 6, width = 11, ...restProps }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 11 6"
    {...restProps}
  >
    <path
      fill={color || "#888"}
      fillRule="evenodd"
      d="M0 0l5.5 5.843L11 0H0z"
      clipRule="evenodd"
    />
  </svg>
);

export default Down;
